import { render, staticRenderFns } from "./w-logo-native.global.vue?vue&type=template&id=634d172a&scoped=true&"
import script from "./w-logo-native.global.vue?vue&type=script&lang=js&"
export * from "./w-logo-native.global.vue?vue&type=script&lang=js&"
import style0 from "./w-logo-native.global.vue?vue&type=style&index=0&id=634d172a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d172a",
  null
  
)

/* custom blocks */
import block0 from "./w-logo-native.global.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports